/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class BetListIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="21.019" height="21" viewBox="0 0 21.019 21" css={Color}>
        <g id="그룹_8774" data-name="그룹 8774" transform="translate(290 -5716)">
          <rect id="사각형_7469" data-name="사각형 7469" width="21" height="21" transform="translate(-290 5716)" fill="red" opacity="0"/>
          <path id="합치기_150" data-name="합치기 150" d="M1.595,14.591A1.6,1.6,0,0,1,0,13V3.778A1.6,1.6,0,0,1,1.595,2.183h.32V1.868A1.871,1.871,0,0,1,3.784,0H19.11a1.871,1.871,0,0,1,1.868,1.868V4.655l-.532.176a1.729,1.729,0,0,0,0,3.292l.535.176v2.785a1.854,1.854,0,0,1-.546,1.323,1.879,1.879,0,0,1-1.322.547h-.594v.041a1.6,1.6,0,0,1-1.094,1.514v.08l-.5,0ZM1,3.778V13a.6.6,0,0,0,.595.595l15.326,0a.6.6,0,0,0,.595-.594V11.107a3,3,0,0,1,0-5.443V3.778a.6.6,0,0,0-.595-.595H1.595A.6.6,0,0,0,1,3.778ZM3.794,6.156l1.494-.013c.923-.007,1.628.257,1.621,1.111a1.053,1.053,0,0,1-.624.985V8.27a1.012,1.012,0,0,1,.838,1.069c-.008.917-.767,1.346-1.76,1.355l-1.608.014ZM4.663,10H5.29c.616,0,.956-.229.956-.7,0-.444-.323-.62-.944-.62H4.675ZM4.68,8,5.2,8c.572,0,.828-.239.828-.6,0-.4-.258-.553-.806-.553H4.69Zm3.262-1.88L10.708,6.1l-.01.757-1.861.015L8.829,7.925,10.414,7.9l-.006.767-1.584.013L8.814,9.9l1.931-.016-.006.766L7.9,10.674Zm4.637.718-1.269.011.007-.756,3.449-.03-.005.755-1.28.011-.032,3.8-.9.007Z" transform="translate(-289.959 5719.205)" fill="#929292"/>
        </g>
      </svg>
    )
  }
}
